<template>
  <main class="main">
    <form class="form" @submit.prevent="createUpdateOrdreFabrication">
      <div class="tabs__container">
        <div class="tabs">
          <div class="tab" :class="{ 'tab--active': step === 0 }" @click="step = 0">
            <PhScroll />
            <span>Informations</span>
          </div>
          <div class="tab" :class="{ 'tab--active': step === 1 }" @click="step = 1">
            <PhFunnel />
            <span>Produits filtration</span>
            <div class="tag" v-if="ordreFabrication.produits_filtration.length">
              {{ ordreFabrication.produits_filtration.length }}
            </div>
          </div>
          <div class="tab" :class="{ 'tab--active': step === 2 }" @click="step = 2">
            <PhWine />
            <span>Vins</span>
            <div class="tag" v-if="ordreFabrication.vins.length">
              {{ ordreFabrication.vins.length }}
            </div>
          </div>
        </div>

        <div class="tab__content">
          <!-- informations -->
          <OrdreFabricationInformations v-if="step === 0" v-model="ordreFabrication" />

          <!-- produits de filtration -->
          <OrdreFabricationProduitsFiltration
            v-else-if="step === 1"
            :produits
            v-model="ordreFabrication"
          />

          <!-- liste des vins -->
          <OrdreFabricationVins v-else-if="step === 2" :produits v-model="ordreFabrication" />
        </div>
      </div>

      <div class="buttons">
        <ButtonElement type="submit" color="bordeaux" :icon="PhFloppyDisk" :disabled="!canSubmit">
          {{ ordreFabricationId ? 'Modifier' : 'Créer' }} l'ordre de fabrication
        </ButtonElement>
      </div>
    </form>
  </main>
</template>

<script setup lang="ts">
import '@/assets/css/components/_ordre-fabrication.css'
import type { OrdreFabricationGet } from '@/interfaces/OrdreFabrication.ts'
import { computed, onMounted, ref, type Ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { PhFloppyDisk, PhFunnel, PhScroll, PhWine } from '@phosphor-icons/vue'
import ButtonElement from '@/components/ButtonElement.vue'
import OrdreFabricationInformations from '@/components/ordre-fabrication/OrdreFabricationInformations.vue'
import OrdreFabricationProduitsFiltration from '@/components/ordre-fabrication/OrdreFabricationProduitsFiltration.vue'
import OrdreFabricationVins from '@/components/ordre-fabrication/OrdreFabricationVins.vue'
import { useLoadingStore } from '@/stores/loading.ts'
import { useCacheStore } from '@/stores/cache.ts'
import { useToastStore } from '@/stores/toast.ts'
import useFetch from '@/composables/useFetch.ts'
import type { ProduitFiltrationList } from '@/interfaces/ProduitFiltrationList.ts'

// stores
const cacheStore = useCacheStore()
const loadingStore = useLoadingStore()
const toastStore = useToastStore()

// dépendances
const api = useFetch()
const route = useRoute()
const router = useRouter()

// données
const step: Ref<number> = ref(0)
const ordreFabrication: Ref<OrdreFabricationGet> = ref({
  produits_filtration: [],
  vins: [],
})
const produits: Ref<ProduitFiltrationList[]> = ref([])

// computed
const ordreFabricationId = computed(() => route.params.id?.toString())
const canSubmit = computed(
  () =>
    cacheStore.online &&
    // champs obligatoires
    ordreFabrication.value.operateur &&
    ordreFabrication.value.equipement &&
    ordreFabrication.value.client &&
    ordreFabrication.value.date_creation,
)

// fonctions
async function getProduits() {
  produits.value = await cacheStore.getProduits()
}
async function getOrdreFabrication() {
  if (ordreFabricationId.value)
    ordreFabrication.value = await cacheStore.getOrdreFabrication(ordreFabricationId.value)
}
async function createUpdateOrdreFabrication() {
  loadingStore.start()
  try {
    if (ordreFabricationId.value) {
      // modification
    } else {
      // création
      await api.post('ordres-fabrication/', ordreFabrication.value)
    }
    toastStore.success(
      `L'ordre de fabrication a bien été ${ordreFabricationId.value ? 'modifié' : 'créé'}.`,
    )
    await router.push({ name: 'ordres-fabrication' })
  } finally {
    loadingStore.stop()
  }
}

onMounted(async () => {
  loadingStore.start()
  try {
    await getProduits()
    await getOrdreFabrication()
  } finally {
    loadingStore.stop()
  }
})
</script>
